// import Swiper styles bundle
import 'swiper/css/bundle';

// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import stringToHTML helper functions
import { stringToHTML } from '../../scripts/stringToHTML.js';

// import section style
import './style.scss';

// import template
const _template = require('./tmpl.html?template').default,
  _template_content = stringToHTML(_template).firstChild;

// Add section to body
document.body.append(_template_content);

// Get all swiper slides
const slider = _template_content.querySelector('#testimonialsSwiper');

const swiper = new Swiper(slider, {
  initialSlide: 2,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },
  effect: 'cards',
  cardsEffect: {
    perSlideOffset: 8,
    perSlideRotate: 1,
  },
  grabCursor: true,
  speed: 1000,
});
